<template>
  <b-modal
    @change="change"
    :visible="value"
    size="md"
    scrollable
    hide-footer
    hide-header
    centered
    :modal-class="`theme-${$setup.theme}-modal`"
  >
    <div class="zoom-message-component p-5">
      <button type="button" class="btn close-btn" @click="$emit('close')">
        <i class="icon-close"></i>
      </button>
      <div :class="`warning-circle ${type} mb-4`">
        <i :class="`icon-${ICON_MAP[type]}`"></i>
      </div>
      <p class="mb-4">{{ message }}</p>
      <b-spinner v-if="loading" variant="primary" small></b-spinner>
      <button
        v-if="!loading"
        type="button"
        class="btn btn-primary px-4"
        @click="$emit('close')"
      >
        Fechar
      </button>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "info"
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ICON_MAP() {
      return {
        error: "close",
        info: "notification",
        success: "check"
      };
    }
  },
  methods: {
    change(val) {
      this.$emit("input", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.zoom-message-component {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: black;
    text-align: center;
  }

  .close-btn {
    position: absolute;
    top: -12%;
    right: -5%;
  }

  .warning-circle {
    border-radius: 50%;
    height: 60px;
    width: 60px;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 40px;
    }

    &.error {
      border: 2px solid red;
      i {
        color: red !important;
      }
    }
    &.info {
      border: 2px solid orange;
      i {
        color: orange !important;
      }
    }
    &.success {
      border: 2px solid green !important;
      i {
        color: green !important;
      }
    }
  }
}
</style>
